import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e622ddfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "translated-content" }
const _hoisted_2 = ["lang"]

import { TRANSLATION_TYPE } from '@/enums/public'
import { ITranslatedContent } from '@/models/shared.model'
import { computed, PropType } from 'vue'
import BaseIcon from '@/components/BaseIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslatedContent',
  props: {
  value: {
    type: [String, Object] as PropType<string | ITranslatedContent>,
    required: true,
  },
  iconSize: {
    type: Number,
    default: 20,
  },
},
  setup(__props) {

const props = __props



const content = computed<string>(() => {
  if (typeof props.value === 'string') {
    return props.value
  }
  return props.value.content
})

const isMachineTranslated = computed<boolean>(() => {
  return props.value?.type === TRANSLATION_TYPE.MACHINE
})

/**
 * Cloud Translation API has some requirements for markup.
 * https://cloud.google.com/translate/markup
 */
const langAttribute = computed<string>(() => {
  if (props.value?.type == TRANSLATION_TYPE.MACHINE) {
    // google translate markup
    return `${props.value.locale}-x-mtfrom-und`
  }

  return props.value.locale
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      lang: _unref(langAttribute),
      class: "translated-content__text"
    }, _toDisplayString(_unref(content)), 9, _hoisted_2),
    (_unref(isMachineTranslated))
      ? (_openBlock(), _createBlock(BaseIcon, {
          key: 0,
          class: "translated-content__icon",
          icon: "translate",
          size: __props.iconSize
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
  ]))
}
}

})